import React, { Component } from 'react'
import astronaut from "../img/astronaut.png";

class Home extends Component {
  render() {
    return (
    <>
      <div className="bg">
        <div className="ui left aligned container buffer">
            <div className="ui column icon">
              <div className="ui vertical social icon">
                <a className="item ico" href="!#">
                  <i className="facebook f icon" />
                </a>
                <a className="item ico" href="!#">
                  <i className="tumblr icon" />
                </a>
                <a className="item ico" href="!#">
                  <i className="instagram icon" />
                </a>
                <a className="item ico" href="!#">
                  <i className="youtube icon" />
                </a>
              </div>
            </div>      
<br/>
            <div className="column">
              <div className="content">
                <h1>
                  Space Exploration Technologies Corp. trading as SpaceX, is a private
                  American aerospace manufacturer headquartered California.
                </h1>
                  <button className="ui inverted button">Explore Space</button>
              </div>
            </div>

            <section className="event" id="event">
              <div className="astronaut">
                <div className="event-content">
                  <img
                    src={astronaut}
                    alt="astronaut"
                    id="astro"
                    width={500}
                  />
                </div>
              </div>
            </section>

          </div>
      </div>
<br/>
      
    </>
    )
  }
}

export default Home;
